module.exports = __webpack_public_path__ + "assets/img/20_1056.66bef7fd.jpg";